import { useMutation, UseMutationOptions, useQueryClient } from "react-query";
import { TRIP_ENDPOINT } from "./constants";
import useFetchWithAuth from "@/fetch/fetchWithAuth";
import { useCurrentTrip } from "@/hooks";

export type UpdateGeneralSettingsVariables = {
  name: string;
  value: boolean | string;
  type: string;
};

type UpdateGeneralSettingsJobResult = {
  success: boolean;
  result: {
    fieldCount: number;
    affectedRows: number;
    insertId: number;
    serverStatus: number;
    warningCount: number;
    message: string;
    protocol41: boolean;
    changedRows: number;
  };
};

type QueryError = {};

const useUpdateGeneralSettingsMutation = (
  options?: UseMutationOptions<
    UpdateGeneralSettingsJobResult,
    QueryError,
    UpdateGeneralSettingsVariables
  >
) => {
  const { fetchWithAuth, cancel } = useFetchWithAuth();
  const { currentTrip } = useCurrentTrip();
  const tid = currentTrip?.id;

  return {
    ...useMutation<
      UpdateGeneralSettingsJobResult,
      QueryError,
      UpdateGeneralSettingsVariables
    >(
      async (input: UpdateGeneralSettingsVariables) => {
        const url = `${TRIP_ENDPOINT}/general-settings/trip/${tid}/name/${input.name}`;
        const inputData = { value: input.value };

        return fetchWithAuth<UpdateGeneralSettingsJobResult>(url, {
          method: "PATCH",
          body: inputData,
        });
      },
      {
        ...options,
      }
    ),
    cancel,
  };
};

export default useUpdateGeneralSettingsMutation;
